import { render, staticRenderFns } from "./ConsultantsRegistered.html?vue&type=template&id=5da2c32c&external"
import script from "./ConsultantsRegistered.vue?vue&type=script&lang=js"
export * from "./ConsultantsRegistered.vue?vue&type=script&lang=js"
import style0 from "./ConsultantsRegistered.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports